var map = {
	"./index": 781,
	"./index.js": 781,
	"./lib/chunksorter": 782,
	"./lib/chunksorter.js": 782,
	"./lib/compiler": 783,
	"./lib/compiler.js": 783,
	"./lib/errors": 784,
	"./lib/errors.js": 784,
	"./lib/loader": 785,
	"./lib/loader.js": 785
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3019;



//////////////////
// WEBPACK FOOTER
// ./~/html-webpack-plugin ^\.\/.*$
// module id = 3019
// module chunks = 0